import { render, staticRenderFns } from "./AdicionarContatosAdicionaisDialog.vue?vue&type=template&id=2cb2acf7&scoped=true&"
import script from "./AdicionarContatosAdicionaisDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarContatosAdicionaisDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarContatosAdicionaisDialog.vue?vue&type=style&index=0&id=2cb2acf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2acf7",
  null
  
)

export default component.exports